import { Injectable } from '@angular/core';
import { fromEventPattern, Observable, of, race, throwError } from 'rxjs';
import { delay, map, switchMap, take, takeUntil, tap } from 'rxjs/operators';

@Injectable()
export class PhotoLoaderService {
    public loadImageFromFile(
        file: File,
        loadTimeout: number
    ): Observable<HTMLImageElement> {
        const imageUrl = URL.createObjectURL(file);
        const revokeUrl = () => URL.revokeObjectURL(imageUrl);
        return this.loadImageFromUrl(imageUrl, loadTimeout).pipe(
            tap(revokeUrl, revokeUrl)
        );
    }

    public loadImageFromUrl(
        imageUrl: string,
        loadTimeout: number
    ): Observable<HTMLImageElement> {
        const image = new Image();
        image.src = imageUrl;

        const addLoadHandler = (handler: (evt: Event) => any) =>
            image.addEventListener('load', handler);
        const removeLoadHandler = (handler: (evt: Event) => any) =>
            image.removeEventListener('load', handler);
        const addErrorHandler = (handler: (evt: ErrorEvent) => any) =>
            image.addEventListener('error', handler);
        const removeErrorHandler = (handler: (evt: ErrorEvent) => any) =>
            image.removeEventListener('error', handler);

        const loadEvent$ = fromEventPattern<Event>(
            addLoadHandler,
            removeLoadHandler
        ).pipe(map(() => image));

        const errorEvent$ = fromEventPattern<ErrorEvent>(
            addErrorHandler,
            removeErrorHandler
        ).pipe(
            switchMap((evt) => {
                return throwError(evt.message);
            })
        );

        const loadComplete$ = race(loadEvent$, errorEvent$).pipe(take(1));

        of(loadTimeout)
            .pipe(delay(loadTimeout), takeUntil(loadComplete$))
            .subscribe((_) => {
                // log the error
                // this._logger.logWarning(`Image loading is taking longer than ${loadTimeout}ms`);
            });

        return loadComplete$;
    }
}
